import React from 'react';
import { KiteIcon } from '@kite/react-kite';
import { SmartLink } from '../SmartLink/SmartLink';
import './ArticleLinks.scss';

export type ArticleLinksInputs = {
    downloadText: string;
    link: {
        title: string;
        uri: string;
    };
    documentUrl: string;
    documentName: string;
};
export const ArticleLinks = ({ inputs }: { inputs: ArticleLinksInputs }) => {
    if (!inputs.link?.uri && !inputs.documentUrl) return null;
    return (
        <div className="article-links">
            {inputs.documentUrl && (
                <SmartLink
                    url={inputs.documentUrl}
                    newWindow
                    download
                    classNames={[`article-links__link`]}
                >
                    {!inputs.downloadText
                        ? `Download ${inputs.documentName}`
                        : inputs.downloadText}
                    <KiteIcon icon="ki-download" size="16px" />
                </SmartLink>
            )}
            {inputs.link?.uri && (
                <SmartLink
                    url={inputs.link?.uri}
                    newWindow
                    classNames={[`article-links__link`]}
                >
                    {inputs.link?.title ? inputs.link?.title : inputs.link?.uri}
                    <KiteIcon icon="ki-arrow-right" size="16px" />
                </SmartLink>
            )}
        </div>
    );
};
